import { createSelector } from 'reselect'

import { selectAuthenticatedPartnerClientIds } from '../authentication'

const getPartners = state => state.partner.partners


export const selectPartners = createSelector(
  getPartners,
  partners => partners.sortBy(p => p.name),
)

export const selectPartnerAccess = createSelector(
  selectPartners,
  selectAuthenticatedPartnerClientIds,
  (partners, ids) => partners
    .filter(p => ids.includes(p.clientId)),
)

export const makeSelectPartner = () => createSelector(
  getPartners,
  (state, { partnerId } = {}) => parseInt(partnerId, 10),
  (partners, partnerId) => partners.find(p => p.id === partnerId, undefined, null),
)



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/partner/selectors.js